import React, {useCallback, useEffect, useState} from 'react';
import {Formik} from "formik";
import FieldCustom from "../Field/FieldCustom";
import loginForm from "../Login/LoginForm";
import AxiosConfig from "../../services/AxiosConfig";
import styles from './../Search/Search.module.css';
import {registerUserToSeanceByCoachAPI} from "../../services/SeanceService";
import {useModal} from "../../contexts/ModalContext";
import {searchCoachs, searchReferents, searchUsers} from "../../services/SearchService";

const SearchCoach = ({ id, onSubmit= null, label = "", act = null }) => {
    const [suggestions, setSuggestions] = useState([]);
    const { showModal } = useModal();

    const handleSuccess = useCallback((message = "Succès") => {
        showModal('success', { children: message, timeout: 3000 });
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 3000 });
    }, [showModal]);

    const fetchSuggestions = async (value, act = null) => {
        if (!value) {
            setSuggestions([]);
            return;
        }
        const response = await searchCoachs(value, act);
        setSuggestions(response);
    };

    const handleInputChange = async (e, setFieldValue, act = null) => {
        const value = e.target.value;
        setFieldValue('email', value);
        await fetchSuggestions(value, act);
    };

    const handleSuggestionClick = (suggestion, setFieldValue, handleSubmit) => {
        setFieldValue('email', suggestion.email);
        setFieldValue('id', suggestion.id);
        setSuggestions([]);
        handleSubmit();
    };

    return (
        <div style={{ display: "flex", flexDirection: "row", width: "100%"}}>
            <Formik
                initialValues={{ email: '', id: '' }}
                onSubmit={async (values, {setSubmitting}) => {

                    if (onSubmit) {
                        onSubmit(values);
                    } else {
                        const response = await registerUserToSeanceByCoachAPI(id, values)
                        if (response.success) {
                            handleSuccess(response.msg);
                        } else {
                            handleError(response.msg);
                        }
                    }
                    setSubmitting(false);
                }}
            >
                {({ handleSubmit, isSubmitting, setFieldValue }) => (
                    <form onSubmit={handleSubmit} className={styles.searchForm} autoComplete="off">
                        <FieldCustom
                            type={"text"}
                            placeholder={"Rechercher par prénom, nom, email..."}
                            id={"email"}
                            name={"email"}
                            label={label}
                            onChange={(e) => handleInputChange(e, setFieldValue, act)}
                        />

                        <div className={styles.listeDeroulanteContainer}>
                            {suggestions.length > 0 ? (
                                <ul className="suggestions">
                                    {suggestions.map(suggestion => (
                                        <li key={suggestion.id}
                                            onClick={() => handleSuggestionClick(suggestion, setFieldValue, handleSubmit)}
                                            style={{ display: "flex", flexDirection: "column" }}
                                        >
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                                                <span>{suggestion.prenom} {suggestion.nom}</span>
                                                <span style={{ fontSize: "var(--fs-secondary)" }}> - {suggestion.email}</span>
                                            </div>
                                            <div
                                                style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "flex-start", gap: "5px" }}
                                            >
                                                {
                                                    suggestion.activiteTypes.map(activite => {
                                                        return (
                                                            <span key={activite.id} style={{
                                                                fontSize: "var(--fs-secondary)",
                                                                padding: "2px 5px",
                                                                backgroundColor: "#444",
                                                                color: "white",
                                                                borderRadius: "5px"
                                                            }}>
                                                            {activite.label}
                                                        </span>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            ) : null }
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default SearchCoach;
